import { createDeferredCatalogue } from './DeferredCatalogueStep';

// Keep the lightweight DOB picker synchronous. Only these existing renderer
// branches use react-datepicker; inspect definitions without changing values.
export const needsCalendar = fields => Array.isArray(fields) && fields.some(field =>
  field?.type === 'calendar' || (field?.type === 'radio' && Array.isArray(field.optionsWithConditional) &&
    field.optionsWithConditional.some(option => Array.isArray(option?.conditionalInputs) &&
      option.conditionalInputs.some(input => input?.type === 'date'))));

export function createDeferredCalendar(loader) {
  const calendar = createDeferredCatalogue({ calendar: loader });
  function Picker(props) { return <calendar.Step type="calendar" {...props} />; }
  function Preload({ fields }) {
    return needsCalendar(fields) ? <calendar.Step type="calendar" preloadOnly /> : null;
  }
  function useReady(fields) { return calendar.useReady(needsCalendar(fields) ? 'calendar' : null); }
  return { Picker, Preload, useReady };
}

const calendar = createDeferredCalendar(() => import('./CalendarInput'));
export const CalendarPreload = calendar.Preload;
export const useCalendarReady = calendar.useReady;
export default calendar.Picker;
